import { render } from "./RootLayout.vue?vue&type=template&id=13f949ba&scoped=true"
import script from "./RootLayout.vue?vue&type=script&lang=js"
export * from "./RootLayout.vue?vue&type=script&lang=js"

import "./RootLayout.vue?vue&type=style&index=0&id=13f949ba&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13f949ba"]])

export default __exports__